angular
  .module('bzConstantsModule')
  .constant('urlConstants', bzGlobal.urlConstants)
